import React from "react";
import "./noOneShift.scss";

import { t } from "i18next";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NoOneShift = () => {
  return (
    <div className="no-one-shift-container">
      <Box
        title={t("calendar.title_event_box")}
        subtitle={t("calendar.subtitle_event_box")}
        callToAction={t("common.explore").toUpperCase()}
        variantButton="success"
      />
    </div>
  );
};
const Box = ({
  title,
  subtitle,
  callToAction,
  variantButton,
  backgroundColor,
  color,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="box-container"
      style={{
        backgroundColor: backgroundColor ? backgroundColor : null,
        color: color ? color : null,
      }}
    >
      <span className="title">{title}</span>
      <span className="subtitle">{subtitle}</span>
      <Button
        variant={variantButton}
        size="sm"
        className="button"
        style={
          backgroundColor ? { color: `${backgroundColor} !important` } : null
        }
        onClick={() => {
          navigate("/explore");
        }}
      >
        {callToAction}
      </Button>
    </div>
  );
};

export default NoOneShift;
